<template>
  <div>
    <multiselect
      v-model="value"
      :placeholder="placeholder"
      :selectLabel="selectLabel"
      :deselectLabel="deselectLabel"
      :preserveSearch="isResetAfter"
      :options="options"
      :disabled="isDisabled"
      :allowEmpty="false"
      :show-labels="false"
      :custom-label="customlabel"
      :class="{ 'is-invalid': isError ? 1 : 0 }"
    >
      <span slot="noOptions">ไม่พบข้อมูล</span>
      <span slot="noResult">ไม่พบข้อมูลที่ค้นหา</span>
    </multiselect>
  </div>
</template>

<script>
// import ilbs
import Multiselect from 'vue-multiselect'

export default {
  name: 'AttributeSelectorComponent',
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.input
      },
    },
    options: {
      type: Array,
      default: null,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    preserveSearch: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'ระบุข้อมูลเพื่อค้นหา',
    },
    selectLabel: {
      type: String,
      default: 'เลือก',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    deselectLabel: {
      type: String,
      default: '',
    },
    noResult: {
      type: String,
      default: 'ไม่พบข้อมูลที่ค้นหา',
    },
  },
  async mounted() {
    this.input = ''
    if (this.value && (this.value.en !== '' || this.value.th !== '')) {
      this.input = this.value
    }
  },
  data() {
    return {
      optionValues: [],
      input: {
        en: '',
        th: '',
      },
      isResetAfter: false,
    }
  },
  watch: {
    value: function(val) {
      if (val !== null && val !== undefined && val !== '') {
        this.input = val
      }
    },
    input: function(val) {
      if (val !== null && val !== undefined && val !== '') {
        this.$emit('input', val)
      }
    },
    preserveSearch: function(val) {
      if (val) {
        this.onReset()
      }
    },
  },
  methods: {
    customlabel({ en, th }) {
      return (en && en !== undefined) || (th && th !== undefined)
        ? `${th}  :  ${en}`
        : ''
    },
    onReset() {
      this.options = []
      this.isResetAfter = true
    },
  },
}
</script>
